// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioMutedOutlinedSvg from "@ant-design/icons-svg/es/asn/AudioMutedOutlined";
import AntdIcon from '../components/AntdIcon';

var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioMutedOutlinedSvg
  }));
};

AudioMutedOutlined.displayName = 'AudioMutedOutlined';
export default React.forwardRef(AudioMutedOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AudioMutedOutlined.js
// module id = 605
// module chunks = 0